import { render, staticRenderFns } from "./PlantingListAsList.vue?vue&type=template&id=2543f650"
import script from "./PlantingListAsList.vue?vue&type=script&lang=js"
export * from "./PlantingListAsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports